const ROUTE_NAME = {
    HOME: '/',
    TWO_FACTOR_AUTH: '/two-factor-auth',
    REGISTRATION: '/registration',
    REGISTRATION_DETAILS: '/registration-details',
    REGISTRATION_COMPLETED: '/registration-completed',
    FIRST_TIME_DASHBOARD: '/first-time-dashboard',
    INVEST_NOW: '/investor/invest-now',
    PERFORMANCE: '/investor/performance',
    PORTFOLIO: '/investor/portfolio',
    TRANSACTION: '/investor/transaction',
    PROFILE: '/investor/profile',
    FAQ_GENERAL_ENQUIRIES: '/investor/faq/general-enquiries',
    FAQ_ELIGIBILITY: '/investor/faq/eligibility',
    FAQ_REGISTRATION_PROCESS: '/investor/faq/registration-process',
    FAQ_INVEST_NOW: '/investor/faq/invest-now',
    FAQ_TYPES_OF_INVESTMENT_NOTES: '/investor/faq/types-of-investment-notes',
    FAQ_REPAYMENTS: '/investor/faq/repayments',
    FAQ_INVESTMENT_MEMOS: '/investor/faq/investment-memos',
    FAQ_RISK_MANAGEMENT: '/investor/faq/risk-management',
    FAQ_FEES_AND_CHARGES: '/investor/faq/fees-and-charges',
    FAQ_DEFAULT_AND_RECOVERY: '/investor/faq/default-and-recovery',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    LOGOUT: '/logout',
}

export default ROUTE_NAME;